import React from 'react';
import { UnderBuild } from './UnderBuild';
const Faq: React.FC = () => {
  return <div>FAQ <UnderBuild/> </div>;
};

export default Faq;